/*
 * Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CDKModule} from '../../cdk.module';
import {MaterialModule} from '../../material.module';
import {AdapterRemovalPointComponent} from './adapter-removal-point/adapter-removal-point.component';
import {InputsModule} from '../inputs/inputs.module';
import {DisplaysModule} from '../displays/displays.module';
import {DialogsModule} from '../dialogs/dialogs.module';
import {SelectsModule} from '../selects/selects.module';
import {ServicesModule} from '../../_services/services.module';
import {AdapterRemovalPendingComponent} from './adapter-removal-pending/adapter-removal-pending.component';
import {TablesModule} from '../tables/tables.module';

@NgModule({
  declarations: [
    AdapterRemovalPendingComponent,
    AdapterRemovalPointComponent
  ],
  exports: [
    AdapterRemovalPendingComponent,
    AdapterRemovalPointComponent
  ],
  imports: [
    CDKModule,
    CommonModule,
    DialogsModule,
    DisplaysModule,
    FormsModule,
    InputsModule,
    MaterialModule,
    ReactiveFormsModule,
    SelectsModule,
    ServicesModule,
    TablesModule,
  ]
})

export class AdaptersModule {
}
